import React, { useState } from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import Paginations from "components/Common/Pagination"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import { ListChecks, Plus, Printer } from "lucide-react"
import BatchPrintingModal from "./BatchPrintingModal"
import { useNavigate } from "react-router-dom"
import { toggleActiveTab } from "../../../store/reducers/cardReducer"
import MarkBatchPrintedModal from "./MarkBatchPrintedModal"

const headers = [
  "S. No.",
  "Batch Serial No",
  "Card File",
  "Number of cards",
  "Generated By",
  "Collection Date",
  "Action",
]

const BatchTable = ({
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  loading,
  data = [],
  showAll,
  permissions,
  isLoading,
  trigger,
  payload,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedBatch, setSelectedBatch] = useState(null)
  const [showBatchPrintingModal, setShowBatchPrintingModal] = useState(false)
  const [showMarkPrintedModal, setShowMarkPrintedModal] = useState(false)

  return (
    <>
      <Card className="user_personal_info theme_card overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((item, index) => (
                    <th key={index}>{t(item)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!loading && data.length === 0
                  ? null
                  : data.map((item, index) => (
                      <tr key={index}>
                        <th scope="row">
                          {(currentPage - 1) * (payload.limit || 50) +
                            index +
                            1}
                        </th>
                        <td>
                          <p
                            className="text-decoration-underline cursor-pointer"
                            onClick={() => {
                              dispatch(toggleActiveTab("generated"))
                              navigate(`/id-cards/${item.uuid}/id-cards-list`)
                            }}
                          >
                            {item.serial_number}
                          </p>
                        </td>
                        <td
                          onClick={() => window.open(item.cards_file, "_blank")}
                          className="text-decoration-underline cursor-pointer text-primary"
                        >
                          {t("View File")}
                        </td>
                        <td>{item.cards_count}</td>
                        <td>{item.exported_by}</td>
                        <td>{item.collection_date}</td>
                        <td>
                          <div className="d-flex gap-2 action_buttons">
                            <Button
                              color="success"
                              onClick={() => {
                                setSelectedBatch(item)
                                setShowBatchPrintingModal(true)
                              }}
                              title={t("Custom Printing")}
                            >
                              <Printer />
                            </Button>
                            <Button
                              color="primary"
                              onClick={() => {
                                setSelectedBatch(item)
                                setShowMarkPrintedModal(true)
                              }}
                              title={t("Mark All Printed")}
                              disabled={
                                +item.printed_cards === +item.cards_count
                              }
                            >
                              <ListChecks />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </div>
          {!loading && data.length === 0 && <NoDataAvailable />}
        </CardBody>
      </Card>
      {!loading && data.length > 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
      {showBatchPrintingModal && (
        <BatchPrintingModal
          isOpen={showBatchPrintingModal}
          toggle={() => {
            setSelectedBatch(null)
            setShowBatchPrintingModal(false)
          }}
          trigger={() => trigger()}
          selectedBatch={selectedBatch}
        />
      )}
      {showMarkPrintedModal && (
        <MarkBatchPrintedModal
          isOpen={showMarkPrintedModal}
          toggle={() => {
            setSelectedBatch(null)
            setShowMarkPrintedModal(false)
          }}
          trigger={() => trigger()}
          selectedBatch={selectedBatch}
        />
      )}
    </>
  )
}

export default BatchTable
